import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initTextHighBullets() {
    const lists = document.querySelectorAll('.textHighBullets__list ul');
    if (!lists.length) return;

    lists.forEach(list => {
        const items = list.querySelectorAll('li');
        if (!items.length) return;

        ScrollTrigger.create({
            trigger: list,
            start: 'top 60%',
            onEnter: () => {
                items.forEach((item, i) => {
                    gsap.delayedCall(i * 0.15, () => item.classList.add('is-visible'));
                });
            },
            onLeaveBack: () => {
                items.forEach((item, i) => {
                    gsap.delayedCall(i * 0.15, () => item.classList.remove('is-visible'));
                });
            },
        });
    });
}